<template>
    <ProgressBar
        v-if="row?.NumberOfStarted != null"
        :value="numberOfFinished"
        :maxValue="NumberOfStarted"
        type="dynamic"
    />
    <span
        v-else
        class="text-end"
        >{{ row?.NumberOfFinished }}</span
    >
</template>

<script lang="ts" setup>
import { ProgressBar } from '@/components';
import type { RaceControlItem } from '@/objects/RaceControlItem';
import { computed } from 'vue';

const props = defineProps<{
    /**
     * The value to display.
     */
    value: number;

    /**
     * The row
     */
    row?: RaceControlItem;
}>();

const NumberOfStarted = computed(() => {
    return props.row?.NumContestants ?? 0;
});

const numberOfFinished = computed(() => {
    if (props.row == undefined) return 0;

    return (props.row.NumberOfFinished ?? 0) + (props.row.NumberOfDNX ?? 0);
});
</script>
